module.exports = __webpack_public_path__ + "img/slide2-s.e22d64e6.jpg";